<template>
    <div class="mt-8 lg:mt-0">
        <hr class="border-t border-gray-300 my-8 lg:hidden" />

        <div id="popular">
            <strong>
                {{ $t('news_popular_posts') }}
            </strong>

            <Loading class="mt-4" :loading="loading">
                <div class="-mx-4 gap-2 flex flex-col">
                    <div v-for="item in $store.getters['posts/getByKey']('popular')?.data" :key="item.id">
                        <TradingRoomPostItem :key="item.id" layout="small_image" :contentstream="item" />
                    </div>
                </div>

                <div class="flex justify-end mt-4">
                    <Pagination :limit="-1" :data="$store.getters['posts/getByKey']('popular')" @pagination-change-page="paginate" />
                </div>
            </Loading>
        </div>

        <hr class="border-t border-gray-300 my-8" />

        <div id="social">
            <strong>
                {{ $t('news_social') }}
            </strong>
            <div class="mt-4 block">
                <TwitterFeed v-if="twitter" />
            </div>
        </div>

        <hr class="border-t border-gray-300 my-8" />

        <div id="our-products">
            <strong>
                {{ $t('news_our_products') }}
            </strong>
            <div class="grid gap-4 mt-4">
                <ProductCategorySingle v-for="category in $store.getters['product_categories/get']()" :key="category.id" :data="category" class="bg-white" />
            </div>
            <div class="flex justify-end mt-4">
                <router-link to="/produkte">
                    <div class="flex flex-row gap-2 group-hover:gap-3 transition-all ease-in-out duration-500 items-center mt-2 cursor-pointer">
                        <span>
                            {{ $t('news_all_products') }}
                        </span>
                        <Icon type="ArrowRight" viewBox="0 0 29 21" width="18" height="10" class="fill-none stroke-current" />
                    </div>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import { MarketOverview } from 'vue-tradingview-widgets';
import { useCcm19Global } from '../../useCcm19Global';
import TwitterFeed from '../social_media/TwitterFeed.vue';

export default {
    components: {
        MarketOverview,
        TwitterFeed
    },
    setup() {
        const { onReady, twitter } = useCcm19Global();
        onReady(() => {});

        return { twitter };
    },

    data: () => ({
        loading: false,
        marketOverviewOptions: {
            tabs: [
                {
                    title: 'Indizes',
                    symbols: [
                        {
                            s: 'FOREXCOM:SPXUSD',
                            d: 'S&P 500'
                        },
                        {
                            s: 'INDEX:NKY',
                            d: 'Nikkei 225'
                        },
                        {
                            s: 'INDEX:DEU40',
                            d: 'DAX Index'
                        },
                        {
                            s: 'FOREXCOM:UKXGBP',
                            d: 'UK 100'
                        },
                        {
                            s: 'BIST:XU100',
                            d: 'BIST 100'
                        },
                        {
                            s: 'CME_MINI:RTY1!',
                            d: 'Russel 2000'
                        },
                        {
                            s: 'CME_MINI:NQ1!',
                            d: 'Nasdaq 100'
                        }
                    ],
                    originalTitle: 'Indices'
                },
                {
                    title: 'Rohstoffe',
                    symbols: [
                        {
                            s: 'COMEX:GC1!',
                            d: 'Gold'
                        },
                        {
                            s: 'COMEX:SI1!',
                            d: 'Silber'
                        },
                        {
                            s: 'COMEX:HG1!',
                            d: 'Kupfer'
                        },
                        {
                            s: 'NYMEX:CL1!',
                            d: 'WTI'
                        },
                        {
                            s: 'NYMEX:PA1!',
                            d: 'Palladium'
                        },
                        {
                            s: 'COMEX:UX1!',
                            d: 'Uranium'
                        },
                        {
                            s: 'CURRENCYCOM:NATURALGAS',
                            d: 'Erdgas'
                        }
                    ],
                    originalTitle: 'Futures'
                },
                {
                    title: 'Altcoins',
                    symbols: [
                        {
                            s: 'BINANCE:ADAUSD',
                            d: 'Cardano'
                        },
                        {
                            s: 'COINBASE:CROUSD',
                            d: 'Cronos'
                        },
                        {
                            s: 'BINANCE:SOLUSD',
                            d: 'Solana'
                        },
                        {
                            s: 'BINANCE:MANAUSD',
                            d: 'Decentraland'
                        },
                        {
                            s: 'BINANCE:LINKUSD',
                            d: 'Chainlink'
                        },
                        {
                            s: 'BINANCE:DOTUSD',
                            d: 'Polkadot'
                        },
                        {
                            s: 'BINANCE:MATICUSD',
                            d: 'Polygon'
                        }
                    ],
                    originalTitle: 'Bonds'
                },
                {
                    title: 'Forex',
                    symbols: [
                        {
                            s: 'FX:EURUSD',
                            d: 'EUR/USD'
                        },
                        {
                            s: 'FX:GBPUSD',
                            d: 'GBP/USD'
                        },
                        {
                            s: 'FX:USDJPY',
                            d: 'USD/JPY'
                        },
                        {
                            s: 'FX:USDCAD',
                            d: 'USD/CAD'
                        },
                        {
                            s: 'FX:EURTRY',
                            d: 'EUR/TRY'
                        },
                        {
                            s: 'FX:EURCAD',
                            d: 'EUR/CAD'
                        },
                        {
                            s: 'FX:GBPJPY',
                            d: 'GBP/JPY'
                        }
                    ],
                    originalTitle: 'Forex'
                }
            ],
            showSymbolLogo: true,
            colorTheme: 'light',
            isTransparent: false,
            displayMode: 'adaptive',
            locale: 'de'
        }
    }),

    watch: {
        '$route.fullPath': function () {
            this.loading = true;
            this.$nextTick(() => {
                this.loading = false;
            });
        }
    },
    mounted() {
        this.loading = true;

        this.indexContentstreams({ key: 'popular' }).then(() => {
            this.loading = false;
        });
    },

    methods: {
        paginate(page) {
            this.indexContentstreams({
                page,
                key: 'popular'
            });
        },
        async indexContentstreams(params) {
            const config = {
                params: {
                    popular: true,
                    limit: 3
                }
            };

            _.merge(config.params, params);

            return await this.$store.dispatch('posts/index', config);
        }
    }
};
</script>
